export const NAME = "core/modal";

export interface ModalState {
    forms: string[];
}

export const initialState: ModalState = {
    forms: [],
};
